import apiService from '@/services/apiService'

export default {
  gbcreaterefnofromupgradepremiumcms: async function (state, data) {
    try {
      const business_id = sessionStorage.getItem('businessId')
      var response = await apiService.post(
        'gbcreaterefnofromupgradepremiumcms',
        data.body,
        {
          params: { ...data.params, business_id },
          responseType: 'arraybuffer'
        }
      )
      return response
    } catch (error) {
      return null
    }
  },
  createCreditCard: async function (state, data) {
    try {
      const business_id = sessionStorage.getItem('businessId')
      var response = await apiService.post('create_credit_card', data, {
        params: { business_id }
      })
      return response
    } catch (error) {
      return null
    }
  },
  addonLineRichmenuPackage: async function (state, payload) {
    try {
      const business_id = sessionStorage.getItem('businessId')
      var response = await apiService.put(
        'addon_line_richmenu_package',
        { addon: 1 },
        {
          params: { line_richmenu_package_id: payload, business_id }
        }
      )
      return response
    } catch (error) {
      return null
    }
  },

  getCardByAccount: async function ({ commit }) {
    try {
      const business_id = sessionStorage.getItem('businessId')
      var response = await apiService.get('credit_card_by_account', {
        business_id
      })
      commit('SET_CARDBYACCOUNT', response.data.data)
      return response
    } catch (error) {
      return error
    }
  },

  deleteCreditCard: async function (state, credit_card_id) {
    try {
      const business_id = sessionStorage.getItem('businessId')
      var response = await apiService.delete('delete_credit_card', {
        credit_card_id,
        business_id
      })
      return response
    } catch (error) {
      return error
    }
  },

  changeActiveCreditCard: async function (state, credit_card_id) {
    try {
      const business_id = sessionStorage.getItem('businessId')
      var response = await apiService.put('change_active_credit_card', {
        params: { credit_card_id, business_id }
      })
      return response
    } catch (error) {
      return error
    }
  },

  servicePaid: async function (state, data) {
    try {
      const business_id = sessionStorage.getItem('businessId')
      var response = await apiService.post('service_paid', data, {
        params: { business_id }
      })
      return response
    } catch (error) {
      return null
    }
  },

  verifyGbTransaction: async function (state, data) {
    try {
      const business_id = sessionStorage.getItem('businessId')
      var response = await apiService.post('verify_gb_transaction', data, {
        params: { business_id }
      })
      return response
    } catch (error) {
      return null
    }
  },

  selectCreditCardId: async function ({ commit }, payload) {
    commit('SELECT_CREDITCARDID', payload)
  },

  purchasePackage: async function (state, data) {
    try {
      const business_id = sessionStorage.getItem('businessId')
      var response = await apiService.post(
        `api/shop/${business_id}/request-purchase-package`,
        data,
        {
          params: { business_id }
        }
      )
      return response
    } catch (error) {
      return error
    }
  },
  verifyPurchasePackage: async function (state, data) {
    try {
      const business_id = sessionStorage.getItem('businessId')
      var response = await apiService.post(
        `api/shop/${business_id}/verify-purchase-package`,
        data,
        {
          params: { business_id }
        }
      )
      return response
    } catch (error) {
      return null
    }
  }
}
